import { isResource } from '@medplum/core'
import type { List } from '@medplum/fhirtypes'
import { MEAL_SERVING_QUEUE_SYSTEM } from '#src/codeSystems.ts'
import { Extension } from '#src/decorators.ts'
import { BaseMealQueue } from '#src/models/meal-queues/BaseMealQueue.ts'
import type { QueryTypes } from '#src/search.ts'
import { hasTag } from '#src/tags.ts'
import { isOfType } from '#src/utils.ts'

export class MealServingQueue extends BaseMealQueue {
  static isInstance(value: unknown): value is List {
    return (
      isResource(value) &&
      isOfType(value, 'List') &&
      hasTag(value, { system: MEAL_SERVING_QUEUE_SYSTEM })
    )
  }

  constructor(
    data?: Omit<List, 'resourceType' | 'mode' | 'status' | 'title'> &
      Partial<Pick<List, 'status'>>
  ) {
    super({
      title: 'Meal Serving Queue',
      ...data,
    })
  }

  static currentQueueQuery(): QueryTypes {
    return {
      title: 'Meal Serving Queue',
      status: 'current',
      _sort: '-_lastUpdated',
      _count: '1',
    }
  }

  @Extension({
    url: MEAL_SERVING_QUEUE_SYSTEM,
    kind: 'valueString',
  })
  servingStation?: string
}
